<template>
    <div>
        <h2 class="text-center">Links</h2>
        <div v-for="(link,index) in form.links" :key="index" class="mb-5">
            <form-input :form="form" :property="`links[${index}]['text']`" :label="`Anchor ${index + 1}`">
                <input v-model="form.links[index].text" class="form-control"/>
                <!-- <span >REMOVE</span> -->
                <i
                    @click="remove(index)"
                    style="cursor:pointer;"
                    class="ml-3 m-nav__link-icon la la-trash"></i>
            </form-input>
            <form-input :form="form" :property="`links[${index}]['url']`" :label="`URL ${index + 1}`">
                <input v-model="form.links[index].url" class="form-control"/>
            </form-input>
        </div>
        <div class="text-right">
            <button class="btn btn-success mt-3 mb-5" @click.prevent.stop="add">Add Link</button>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        form: {
            required: true,
        },
    },
    data() {
        return {
            formLocal: this.form
        };
    },
    watch: {
        form(){
            // console.log('form changed');
            // console.log(this.form);
            this.formLocal = this.form;
        },
    },
    // mounted() {
    //     console.log('mounted');
    //     console.log(this.form);
    // },
    methods: {
        add() {
            this.formLocal.links.push({
                url: "",
                text: "",
            })
        },
        remove(index) {
            // console.log('remove');
            // console.log(index);
            this.form.links.splice(index, 1);
        },
    },
};
</script>


// WEBPACK FOOTER //
// resources/js/forms/FormLinks.vue